import { useCallback } from 'react';
import { useParams } from 'react-router';

import { EmailEntry, View } from '@/src/components/project/Inbox2/types';
import useInboxSearchParams from '@/src/components/project/Inbox2/useInboxSearchParams';
import { queryClient } from '@/src/lib/react-query/react-query';

import { EMAIL_THREAD_PAGE_LIMIT } from './EmailEntries';

import { emailEntriesKeys } from '../../../api/getEmailEntries';

type useSyncSelectedEmailEntryListItemProps = {
  emailEntry: EmailEntry;
};
export const useSyncSelectedEmailEntryListItem = ({
  emailEntry,
}: useSyncSelectedEmailEntryListItemProps) => {
  const { projectId } = useParams<{ projectId: string }>();
  const { view } = useInboxSearchParams();

  const handleSetLastEmailEntryItemAsSelected = useCallback(() => {
    queryClient.setQueryData(
      [
        ...emailEntriesKeys.lists({
          projectId,
          inboxEntryId: emailEntry.inboxEntryId,
          trash: view === View.Trash,
        }),
        EMAIL_THREAD_PAGE_LIMIT,
      ],
      (prev: any) => {
        if (!prev) {
          return prev;
        }
        return {
          ...prev,
          pages: prev.pages.map((page) => {
            const newEmailEntries = page.data.emails;
            return {
              ...page,
              data: {
                ...page.data,
                emails: newEmailEntries.map((ee, index) => {
                  // if last item
                  if (newEmailEntries.length === index + 1) {
                    return {
                      ...ee,
                      isSelected: true,
                    };
                  }
                  return ee;
                }),
              },
            };
          }),
        };
      }
    );
  }, [emailEntry, view, projectId]);

  return handleSetLastEmailEntryItemAsSelected;
};
